import styled from "styled-components";

export const StyledImageWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  margin-right: 15px;
  position: relative;
`;

export const StyledDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StyledHex = styled.div<{ hex: string }>`
  border-radius: 50%;
  background-color: ${({ hex }) => hex};
  height: 12px;
  width: 12px;
`;
